import { useNavigate } from "react-router-dom";
import {
  Body as BaseBody,
  ContentContainer,
  Header,
  NavigateBeforeButton,
} from "../../components";
import { RequestType } from "../../interfaces";
import { DoctorDocumentReadinessModal } from "@components/documentCreation";
import { useDoctorDocumentReadiness } from "@hooks";
import { Card } from "./components/Card";
import { useCallback } from "react";
import type { Theme } from "@mui/material";
import { Box, styled, Typography, useMediaQuery } from "@mui/material";

const DocumentTypesContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: 24,
  width: "100%",
  padding: 0,
}));

const Body = styled(BaseBody)(() => ({
  alignItems: "normal",
}));

const Title = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

export function NewDocumentType() {
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"));
  const navigate = useNavigate();
  const { checkSigningBlock, modalProps } = useDoctorDocumentReadiness();

  const handleDocumentTypeClick = useCallback(
    async (documentType: RequestType) => {
      // Past the deadline, a doctor creates no document of any type until
      // they validate their identity.
      if (await checkSigningBlock()) return;
      navigate(`/app/nuevo-documento/paciente`, {
        state: { documentType },
      });
    },
    [navigate, checkSigningBlock],
  );

  return (
    <>
      <Header
        useMekiDocIcon={isDesktop}
        title={!isDesktop ? "Nuevo documento" : undefined}
        titleColor="black"
        left={<NavigateBeforeButton onClick={() => navigate("/app/solicitudes")} />}
      />
      <ContentContainer disableGutters>
        <Body>
          <Title variant="h4" fontWeight={"medium"}>
            Nuevo documento
          </Title>
          <DocumentTypesContainer>
            {Object.values(RequestType).map((documentType) => (
              <Card
                key={documentType}
                documentType={documentType}
                onClick={() => handleDocumentTypeClick(documentType)}
              />
            ))}
          </DocumentTypesContainer>
        </Body>
      </ContentContainer>
      <DoctorDocumentReadinessModal {...modalProps} />
    </>
  );
}
